const delInitialState = {
  deleting: false,
};

const del = (state = delInitialState, action) => {
  switch (action.type) {
    case 'DELETE_SEGMENT':
      return {
        ...state,
        deleting: true,
      };

    case 'DELETE_SEGMENT_SUCCESS':
      return delInitialState;

    case 'DELETE_SEGMENT_FAILURE':
      return {
        ...state,
        deleting: false,
      };

    default:
      return state;
  }
};

export default del;

export const isDeleting = (state) => state.deleting;
